/* SilentoPro : saut vers l'ancre, recale tant que la page bouge (images qui se chargent) */
(function () {
  if (window.__silentoAnchor) return;
  window.__silentoAnchor = true;

  function target() {
    var id = decodeURIComponent(location.hash.slice(1));
    return id ? document.getElementById(id) : null;
  }

  function jump(smooth) {
    var el = target();
    if (!el) return;
    el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  function settle() {
    if (!location.hash || !target()) return;
    var start = Date.now();
    jump(false);
    var timer = setInterval(function () {
      var el = target();
      if (!el) return;
      var top = el.getBoundingClientRect().top;
      if (Math.abs(top) > 4) jump(false);          // la page a bouge : on recale
      if (Date.now() - start > 3000) clearInterval(timer);
    }, 200);
  }

  if (location.hash) {
    if (document.readyState === 'complete') settle();
    else window.addEventListener('load', settle);
  }
  function settleAfterMove() {
    // Le recalage servait a rattraper les images qui se chargent, mais il
    // repartait aussitot en saut instantane et hachait le defilement doux.
    // On le laisse donc finir, et on ne corrige que les gros decalages.
    setTimeout(function () {
      var start = Date.now();
      var timer = setInterval(function () {
        var el = target();
        if (!el) return clearInterval(timer);
        if (Math.abs(el.getBoundingClientRect().top) > 40) jump(true);
        if (Date.now() - start > 2000) clearInterval(timer);
      }, 400);
    }, 800);
  }

  // le lien vient du menu tiroir : on le referme avant de descendre (sinon le scroll est bloque)
  function closeDrawers(link, e) {
    var det = document.querySelector('details.menu-drawer-container[open], #Details-menu-drawer-container[open]');
    if (!det) return false;
    var hd = link.closest('header-drawer') || document.querySelector('header-drawer');
    if (hd && typeof hd.closeMenuDrawer === 'function') {
      try { hd.closeMenuDrawer(e); } catch (err) {}
    }
    det.classList.remove('menu-opening');
    var sum = det.querySelector('summary');
    if (sum) sum.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    // l'animation de fermeture du theme peut ne jamais finir : on force
    setTimeout(function () {
      det.removeAttribute('open');
      det.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); d.classList.remove('menu-opening'); });
    }, 300);
    return true;
  }

  // clic sur un lien d'ancre de la page : on gere nous-memes (le navigateur ne bouge pas si l'ancre est deja dans l'URL)
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    var url;
    try { url = new URL(href, location.href); } catch (err) { return; }
    // lien vers une autre page : on laisse le navigateur faire
    if (url.pathname !== location.pathname || !url.hash) return;
    var id = decodeURIComponent(url.hash.slice(1));
    if (!id || !document.getElementById(id)) return;
    e.preventDefault();
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    else location.hash = id;
    var closed = closeDrawers(link, e);
    if (closed) {
      setTimeout(function () { jump(true); settleAfterMove(); }, 320);
    } else {
      jump(true);
      settleAfterMove();
    }
  });

  window.addEventListener('hashchange', function () {
    jump(true);
    settleAfterMove();
  });
})();
